<template>
  <div class="status-bar">
    <div class="status-bar__full" :style="{width: points + '%'}" :class="{'status-bar__full--critical': critical}">
    </div>
    <div class="status-bar__target" v-if="target" :style="{left: target + '%'}"></div>
  </div>
</template>

<script>
export default {
  props: ["points", "target"],

  computed: {
    critical() {
      return this.target && this.points < this.target;
    }
  }
};
</script>

<style scoped lang="scss">
$red-light: #FF5959;
$red-dark: #CD2626;
$orange-light: #FFC34D;
$orange-dark: #F37C55;
$blue-light: #00D5FF;
$blue-dark: #266EFF;
$green-light: #CBE545;
$green-dark: #00CA83;
$purple-light: #642DB3;
$purple-dark: #3B09AF;

.status-bar {
  height: 12px;
  width: 150px;
  position: relative;
  background-color: white;

  &__full {
    height: 100%;
    background-color: $green-dark;

    &--critical {
      background-color: $red-dark;
    }
  }

  &__target {
    height: 100%;
    width: 3px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
  }
}
</style>
